var _defs, _path, _path2, _path3, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.087,
    height: 29,
    viewBox: "0 0 33.087 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M500.758,619.053H529.25a.79.79,0,0,0,.682-1.188l-14.246-24.413a.79.79,0,0,0-1.365,0h0l-14.246,24.413a.79.79,0,0,0,.682,1.188Zm13.692-18.342h1.108a.688.688,0,0,1,.687.73l-.554,9.123a.688.688,0,0,1-1.373,0l-.554-9.123A.688.688,0,0,1,514.45,600.711ZM515,612.4a1.86,1.86,0,1,1-1.859,1.86A1.859,1.859,0,0,1,515,612.4Z",
    transform: "translate(-498.46 -591.557)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M452.233,572.061h28.492a2.294,2.294,0,0,0,1.981-3.45L468.46,544.2a2.294,2.294,0,0,0-3.962,0l-14.246,24.413a2.294,2.294,0,0,0,1.981,3.45Zm-.682-2.692L465.8,544.957h0a.79.79,0,0,1,1.365,0l14.246,24.412a.79.79,0,0,1-.682,1.188H452.233a.79.79,0,0,1-.682-1.188Z",
    transform: "translate(-449.936 -543.061)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M959.264,857.273a.688.688,0,0,0,1.373,0l.554-9.123a.688.688,0,0,0-.687-.73H959.4a.688.688,0,0,0-.687.73Z",
    transform: "translate(-943.407 -838.266)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.859,
    cy: 1.86,
    rx: 1.859,
    ry: 1.86,
    transform: "translate(14.685 20.841)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warningAlert.505273030b93eb27872d169a85397502.svg";
export { ForwardRef as ReactComponent };